<!-- Improved Footer Component with Better Mollie Badge Integration -->
<footer class="bg-white border-t border-gray-200 mt-12">
  <div class="max-w-7xl mx-auto px-4 py-8">
    <div class="flex flex-col md:flex-row justify-between items-center">
      <!-- Footer Logo -->
      <div class="mb-6 md:mb-0">
        <a href="/" class="flex items-center">
          <img [src]="logoImagePath" alt="CleverDeals.net" class="h-6" />
        </a>
      </div>

      <!-- Footer Links -->
      <div class="flex flex-wrap justify-center gap-6 mb-6 md:mb-0">
        <a href="/about-us" class="text-gray-600 hover:text-[#FF5858] transition-colors">
          About Us
        </a>
        <a href="/privacy-policy" class="text-gray-600 hover:text-[#FF5858] transition-colors">
          Privacy Policy
        </a>
        <a href="/alternative-to-kickstarter" class="text-gray-600 hover:text-[#FF5858] transition-colors">
          Alternative to KickStarter
        </a>
        <a href="/suggest-deal" class="text-gray-600 hover:text-[#FF5858] transition-colors">
          Suggest a Deal
        </a>
        <a href="/suppliers" class="text-gray-600 hover:text-[#FF5858] transition-colors">
          Suppliers
        </a>
        <a href="/terms-conditions" class="text-gray-600 hover:text-[#FF5858] transition-colors">
          Terms & Conditions
        </a>
      </div>

      <!-- Copyright and Mollie Badge -->
      <div class="flex flex-col items-center md:items-end space-y-2">
        <div class="text-gray-500 text-sm">
          &copy; {{ currentYear }} CleverDeals.net. All rights reserved.
        </div>
        <img src="assets/images/mollie-badge.png" alt="Secure payments powered by mollie" class="h-10 opacity-90" />
      </div>
    </div>
  </div>
</footer>